import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = () => {
  const body = new Array(5).fill(null).map((i, ind) => {
    const yStrip = 140 * ind
    return (
      <React.Fragment key={ind}>
        {
          <>
            <rect x='15' y={yStrip + 15} rx='8' ry='8' width='80' height='22' />
            <circle cx='162' cy={yStrip + 25} r='10' />
            <rect x='178' y={yStrip + 17} rx='3' ry='3' width='180' height='15' />
            <circle cx='557' cy={yStrip + 25} r='10' />
            <rect x='573' y={yStrip + 17} rx='3' ry='3' width='130' height='15' />

            <rect x='15' y={yStrip + 73} rx='3' ry='3' width='200' height='15' />
            <rect x='575' y={yStrip + 68} rx='3' ry='3' width='85' height='36' />
          </>
        }
      </React.Fragment>
    )
  })
  return (
    <ContentLoader
      speed={2}
      width={783}
      height={700}
      viewBox='0 0 783 700'
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'
    >
      {body}
    </ContentLoader>
  )
}

export default Loader